import { useEffect, useState } from 'react';

import { useAppDispatch, useAppSelector } from '../../App/redux/store';
import { appManagerActions } from '../../store/appManager/actions';
import { getAppManagerState } from '../../store/appManager/reducer';

interface TabItemProps {
  index: number;
  type: string;
  children: React.ReactNode;
}

const TabItem = ({ index, type, children }: TabItemProps) => {
  const [keyName, setKeyName] = useState<string>('');
  const appManager = useAppSelector(getAppManagerState);
  const dispatch = useAppDispatch();

  useEffect(() => {
    switch (type) {
      case 'assistance':
        setKeyName('selectedAssistanceTab');
        break;
      case 'adDetailsForms':
        setKeyName('selectedAdDetailsFormTab');
        break;
      default:
        setKeyName('selectedAccountTab');
    }
  }, [type]);

  const handleClick = () => {
    dispatch((appManagerActions as any)[keyName].set(index));
  };
  return (
    <li
      onClick={handleClick}
      className={
        appManager[keyName] === index ? 'tabs-list-elt active' : 'tabs-list-elt'
      }
    >
      {children}
    </li>
  );
};

export default TabItem;
